import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            width: '100%',
            height: '100%',
            maxHeight: '80vh',
            overflow: 'hidden',
        },
        tableContainer: {
            maxHeight: '40vh',
            overflowY: 'auto',
        },
        tableContentWrapper: {
            overflow: 'hidden',
        },
        gridCardWrapper: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr)) !important',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
        },
        button: {
            width: '160px',
            alignSelf: 'center',
        },
        importantText: {
            fontWeight: 700,
            textTransform: 'uppercase',
        },
        textMessage: {
            marginTop: theme.spacing(3),
        },
    }
})

export default useStyles
